import styled from "@emotion/styled"
import { rhythm, scale } from "@utils/typography"

const Callout = styled.p`
  ${scale(1 / 2)};
  margin: ${rhythm(1)} 0;
`

const Caption = styled.p`
  ${props => (props.scale ? scale(props.scale) : scale(1 / 4))};
  ${props => props.colour && `color: ${props.colour};`}
  font-style: italic;
  ${props => (props.align ? `text-align: ${props.align};` : null)}
`

const Cite = styled.cite`
  font-weight: 700;
`

const Heading = styled.h1`
  color: ${props => (props.colour ? props.colour : props.theme.colour)};
`

const Pullquote = styled.p`
  border-left: 4px solid
    ${props => (props.colour ? props.colour : props.theme.colours.primary)};
  color: ${props =>
    props.colour ? props.colour : props.theme.colours.primary};
  ${scale(1 / 4)};
  font-weight: 500;
  padding-left: ${rhythm(1)};
  margin: ${rhythm(1)} 0;
`

const Strong = styled.strong`
  font-weight: 600;
  text-transform: uppercase;
`

const Small = styled.small`
  display: inline-block;
  margin-bottom: ${rhythm(1 / 2)};
  color: ${props => props.theme.colours.light};
`

const StatLabel = styled.p`
  ${scale(1 / 6)};
  text-align: center;
  font-weight: 600;
`

export { Callout, Caption, Cite, Heading, Pullquote, Strong, Small, StatLabel }
